'use strict';

var React = require('react');
var ACHAppIcon = require('../../../../IconsAndImages/AppIcons/ACHAppIcon.js');
var BakerAppIcon = require('../../../../IconsAndImages/AppIcons/BakerAppIcon.js');
var BroadlyAppIcon = require('../../../../IconsAndImages/AppIcons/BroadlyAppIcon.js');
var CarrierEnterpriseAppIcon = require('../../../../IconsAndImages/AppIcons/CarrierEnterpriseAppIcon.js');
var ConvertAppIcon = require('../../../../IconsAndImages/AppIcons/ConvertAppIcon.js');
var CreditCardAppIcon = require('../../../../IconsAndImages/AppIcons/CreditCardAppIcon.js');
var DispatchAppIcon = require('../../../../IconsAndImages/AppIcons/DispatchAppIcon.js');
var EcmdAppIcon = require('../../../../IconsAndImages/AppIcons/EcmdAppIcon.js');
var EmailAppIcon = require('../../../../IconsAndImages/AppIcons/EmailAppIcon.js');
var FacebookAppIcon = require('../../../../IconsAndImages/AppIcons/FacebookAppIcon.js');
var FundboxAppIcon = require('../../../../IconsAndImages/AppIcons/FundboxAppIcon.js');
var GemaireAppIcon = require('../../../../IconsAndImages/AppIcons/GemaireAppIcon.js');
var GoogleAppIcon = require('../../../../IconsAndImages/AppIcons/GoogleAppIcon.js');
var GoogleCalendarAppIcon = require('../../../../IconsAndImages/AppIcons/GoogleCalendarAppIcon.js');
var HousecallAppIcon = require('../../../../IconsAndImages/AppIcons/HousecallAppIcon.js');
var InstapayAppIcon = require('../../../../IconsAndImages/AppIcons/InstapayAppIcon.js');
var MastermindAppIcon = require('../../../../IconsAndImages/AppIcons/MastermindAppIcon.js');
var NextStepAppIcon = require('../../../../IconsAndImages/AppIcons/NextStepAppIcon.js');
var NicejobAppIcon = require('../../../../IconsAndImages/AppIcons/NicejobAppIcon.js');
var OnCallairAppIcon = require('../../../../IconsAndImages/AppIcons/OnCallairAppIcon.js');
var PodiumAppIcon = require('../../../../IconsAndImages/AppIcons/PodiumAppIcon.js');
var PostcardAppIcon = require('../../../../IconsAndImages/AppIcons/PostcardAppIcon.js');
var QuickbooksAppIcon = require('../../../../IconsAndImages/AppIcons/QuickbooksAppIcon.js');
var ReferralAppIcon = require('../../../../IconsAndImages/AppIcons/ReferralAppIcon.js');
var ReviewsAppIcon = require('../../../../IconsAndImages/AppIcons/ReviewsAppIcon.js');
var SalesProposalAppIcon = require('../../../../IconsAndImages/AppIcons/SalesProposalAppIcon.js');
var SearchEnginesAppIcon = require('../../../../IconsAndImages/AppIcons/SearchEnginesAppIcon.js');
var ServicePlanAppIcon = require('../../../../IconsAndImages/AppIcons/ServicePlanAppIcon.js');
var SuperproAppIcon = require('../../../../IconsAndImages/AppIcons/SuperproAppIcon.js');
var TimeTrackingAppIcon = require('../../../../IconsAndImages/AppIcons/TimeTrackingAppIcon.js');
var ThumbtackAppIcon = require('../../../../IconsAndImages/AppIcons/ThumbtackAppIcon.js');
var WebsiteBuilderAppIcon = require('../../../../IconsAndImages/AppIcons/WebsiteBuilderAppIcon.js');
var YelpAppIcon = require('../../../../IconsAndImages/AppIcons/YelpAppIcon.js');
var ZapierAppIcon = require('../../../../IconsAndImages/AppIcons/ZapierAppIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var AppTileInfo = {
  'ACH': {
    icon: React__default["default"].createElement(ACHAppIcon, {
      size: 'xlarge'
    }),
    appName: 'ACH',
    openAppURL: 'function'
  },
  'BAKER': {
    icon: React__default["default"].createElement(BakerAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Baker',
    openAppURL: 'function'
  },
  'BROADLY': {
    icon: React__default["default"].createElement(BroadlyAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Broadly',
    openAppURL: 'function'
  },
  'CARRIERENTERPRISE': {
    icon: React__default["default"].createElement(CarrierEnterpriseAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Carrier Enterprise',
    openAppURL: 'function'
  },
  'CONVERT': {
    icon: React__default["default"].createElement(ConvertAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Convert',
    openAppURL: 'function'
  },
  'CREDIT_CARD': {
    icon: React__default["default"].createElement(CreditCardAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Credit card',
    openAppURL: 'function'
  },
  'DISPATCH': {
    icon: React__default["default"].createElement(DispatchAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Dispatch',
    openAppURL: 'function'
  },
  'ECMD': {
    icon: React__default["default"].createElement(EcmdAppIcon, {
      size: 'xlarge'
    }),
    appName: 'ECMD',
    openAppURL: 'function'
  },
  'EMAIL': {
    icon: React__default["default"].createElement(EmailAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Email',
    openAppURL: 'function'
  },
  'FACEBOOK': {
    icon: React__default["default"].createElement(FacebookAppIcon, {
      size: 'xlarge'
    }),
    appName: '',
    openAppURL: 'function'
  },
  'FUNDBOX': {
    icon: React__default["default"].createElement(FundboxAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Fundbox',
    openAppURL: 'function'
  },
  'GEMAIRE': {
    icon: React__default["default"].createElement(GemaireAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Gemaire',
    openAppURL: 'function'
  },
  'GOOGLE_CALENDAR': {
    icon: React__default["default"].createElement(GoogleCalendarAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Google calendar',
    openAppURL: 'function'
  },
  'GOOGLE_RESERVE': {
    icon: React__default["default"].createElement(GoogleAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Google reserve',
    openAppURL: 'function'
  },
  'HOUSECALL': {
    icon: React__default["default"].createElement(HousecallAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Housecall',
    openAppURL: 'function'
  },
  'INSTAPAY': {
    icon: React__default["default"].createElement(InstapayAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Instapay',
    openAppURL: 'function'
  },
  'MASTERMIND': {
    icon: React__default["default"].createElement(MastermindAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Mastermind',
    openAppURL: 'function'
  },
  'NICE_JOB': {
    icon: React__default["default"].createElement(NicejobAppIcon, {
      size: 'xlarge'
    }),
    appName: 'NiceJob',
    openAppURL: 'function'
  },
  'ON_CALL_AIR': {
    icon: React__default["default"].createElement(OnCallairAppIcon, {
      size: 'xlarge'
    }),
    appName: 'OnCall Air',
    openAppURL: 'function'
  },
  'PODIUM': {
    icon: React__default["default"].createElement(PodiumAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Podium',
    openAppURL: 'function'
  },
  'POSTCARDS': {
    icon: React__default["default"].createElement(PostcardAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Postcards',
    openAppURL: 'function'
  },
  'QUICKBOOKS_ONLINE': {
    icon: React__default["default"].createElement(QuickbooksAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Quickbooks Desktop',
    openAppURL: 'function'
  },
  'REFERRAL': {
    icon: React__default["default"].createElement(ReferralAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Referral',
    openAppURL: 'function'
  },
  'REVIEWS': {
    icon: React__default["default"].createElement(ReviewsAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Reviews',
    openAppURL: 'function'
  },
  'SALES_PROPOSAL': {
    icon: React__default["default"].createElement(SalesProposalAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Sales Proposal',
    openAppURL: 'function'
  },
  'SEARCH_ENGINES': {
    icon: React__default["default"].createElement(SearchEnginesAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Search Engines',
    openAppURL: 'function'
  },
  'SERVICE_AGREEMENT': {
    icon: React__default["default"].createElement(ServicePlanAppIcon, {
      size: 'xlarge'
    }),
    appName: 'ServicePlanAppIcon',
    openAppURL: 'function'
  },
  'SUPERPRO': {
    icon: React__default["default"].createElement(SuperproAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Superpro',
    openAppURL: 'function'
  },
  'TIME_TRACKING': {
    icon: React__default["default"].createElement(TimeTrackingAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Time Tracking',
    openAppURL: 'function'
  },
  'THUMBTACK': {
    icon: React__default["default"].createElement(ThumbtackAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Thumbtack',
    openAppURL: 'function'
  },
  'TOURMALINE_LABS': {
    icon: React__default["default"].createElement(NextStepAppIcon, {
      size: 'xlarge'
    }),
    appName: 'NextStep',
    openAppURL: 'function'
  },
  'WEBSITE_BUILDER': {
    icon: React__default["default"].createElement(WebsiteBuilderAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Website builder',
    openAppURL: 'function'
  },
  'YELP': {
    icon: React__default["default"].createElement(YelpAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Yelp',
    openAppURL: 'function'
  },
  'ZAPIER': {
    icon: React__default["default"].createElement(ZapierAppIcon, {
      size: 'xlarge'
    }),
    appName: 'Zapier',
    openAppURL: 'function'
  }
}; // HC_CHAT = 'HC_CHAT'

module.exports = AppTileInfo;
